import { Claim, ClaimStatus, ClaimStatusInternal, RawClaim } from 'domains/billing';
import { getRealClaimBalance, getShownClaimBalance } from 'domains/claims/balance';
import { getClaimShownStatus } from 'domains/claims/status';

export const formatRawClaim = (rawClaim: RawClaim): Claim => {
  const realStatus: ClaimStatus = rawClaim.claims[0].status;

  const realBalanceInCents = getRealClaimBalance(rawClaim);
  const shownBalanceInCents = getShownClaimBalance(realBalanceInCents, realStatus);

  const shownInternalStatus: ClaimStatusInternal = getClaimShownStatus(realStatus, realBalanceInCents);

  const noteId = rawClaim.external_id.replace('claim_', '');

  return { ...rawClaim, shownInternalStatus, realBalanceInCents, shownBalanceInCents, noteId };
};
